/**
 * Controla la tabla de inspecciones.
 */
CiudadanoCtrl.$inject = ['$log', '$scope', 'dialogService', 'CiudadanoIncidencia', 'Incidencia', 'Tarea'];
export default function CiudadanoCtrl($log, $scope, dialogService, CiudadanoIncidencia, Incidencia, Tarea) {

    var templateDialogAdd = require('./crearOEditCiudadanoDialog.html');

    var mostrarInfo = false;

    $scope.anyadirCiudadano = function (incidenciaId, tareaId) {
        $log.debug('Añadiendo ciudadano a la incidencia ' + incidenciaId + ' ...');

        if (issetAndNotEmpty(tareaId)) mostrarInfo = true;

        var botones = {
            botonOk: ucfirst(Lang.get('nombres.anyadir')),
        };

        doDialog(templateDialogAdd, {mostrarInfo: mostrarInfo}, ucfirst(Lang.get('nombres.anyadir')) + " " + Lang.choice('nombres.ciudadano', 1),
            "dialogCrearEditarCiudadano", botones)
            .then(function (result) {
                anyadirCiudadanoServer(incidenciaId, result.ciudadano).then(function () {
                        success(Lang.choice('nombres.ciudadano', 1) + " " + Lang.choice('nombres.anyadido', 1), incidenciaId, tareaId);
                    }, error
                );
            });
    };

    $scope.editarCiudadano = function (incidenciaId, ciudadanoId, tareaId) {
        $log.debug('Editar ciudadano a la incidencia ' + incidenciaId + ' ...');
        if (issetAndNotEmpty(tareaId)) mostrarInfo = true;

        CiudadanoIncidencia.edit({incidenciaId: incidenciaId, ciudadanoId: ciudadanoId}, function (data) {
            var botones = {
                botonOk: ucfirst(Lang.get('nombres.editar')),
            };

            var model = {ciudadano: data, mostrarInfo: mostrarInfo};
            doDialog(templateDialogAdd, model, ucfirst(Lang.get('nombres.editar')) + " " + Lang.choice('nombres.ciudadano', 1),
                "dialogCrearEditarCiudadano", botones)
                .then(function (result) {
                    editarCiudadanoServer(incidenciaId, ciudadanoId, result.ciudadano).then(
                        function (data) {
                            success(Lang.choice('nombres.ciudadano', 1) + " " + Lang.choice('nombres.editado', 1), incidenciaId, tareaId);
                        }, error
                    );
                });
        }, function (error) {
            Sigo.UI.Messages.open([error.data.messages], 0);
        });
    };

    var success = function (mensaje, incidenciaId, tareaId) {
        $.toast({loader: false, text: ucfirst(mensaje), icon: 'success', hideAfter: 5000});
        if (issetAndNotEmpty(tareaId)) {
            Tarea.get({tareaId: tareaId}, function (data) {
                actualizaFilaVTarea(JSON.parse(JSON.stringify(data)));
            });
        } else {
            Incidencia.get({incidenciaId: incidenciaId}, function (data) {
                actualizaFilaVIncidencia(JSON.parse(JSON.stringify(data)));
            });
        }
    };

    var error = function (error) {
        var mensaje = typeof error.data.message !== "undefined" ? error.data.message : error.data.messages;
        $.toast({loader: false, text: mensaje, icon: 'error', hideAfter: 5000});
    };

    function anyadirCiudadanoServer(incidenciaId, ciudadano) {
        $log.debug('Añadiendo inspeccion a la incidencia ' + incidenciaId + '...');
        return CiudadanoIncidencia.save({incidenciaId: incidenciaId}, ciudadano).$promise;
    }

    function editarCiudadanoServer(incidenciaId, ciudadanoId, ciudadano) {
        $log.debug('Editando el ciudadano ' + ciudadanoId + ' a la incidencia ' + incidenciaId + '...');
        return CiudadanoIncidencia.update({incidenciaId: incidenciaId, ciudadanoId: ciudadanoId}, ciudadano).$promise;
    }

    function doDialog(template, model, titulo, idDialog, extraOptions) {
        // jQuery UI dialog options
        var options = {
            autoOpen: false,
            modal: true,
            title: titulo,
            minWidth: 600,
            minHeight: false
        };

        if (!issetAndNotEmpty(extraOptions.botonCancell)) extraOptions.botonCancell = ucfirst(Lang.get('nombres.cancelar'));

        // Open the dialog using template from script
        return dialogService.open(idDialog, template, model, options, extraOptions);
    }
}